import { Modal, Button } from "antd";

const ExpiredModal = ({ visible, setVisible }) => {
  const handleCancel = () => setVisible(false);
  return (
    <Modal
      open={visible}
      title="Cédula vencida"
      onCancel={handleCancel}
      width={1000}
      footer={[
        <Button key="cancel" onClick={handleCancel}>
          OK
        </Button>,
      ]}
    >
      <p>La cédula subida está vencida</p>
    </Modal>
  );
};

export default ExpiredModal;
